import { Box, Paper, Stack, Typography } from '@mui/material'
import { FunctionComponent } from 'react'
import { IconPicker } from '../display-elements-components/icon-picker'
import { IconName } from '../../../shared/interfaces/icon-picker.model'
import { Link } from 'react-router-dom'

export const InformationBox: FunctionComponent<{
  text: string,
  actionText?: string,
  link?: string
  icon: IconName,
  marginTop?: number,
  marginBottom?: number
  additionalText?: string,
}> = ({
  text,
  actionText,
  link,
  marginTop = 0,
  marginBottom = 0,
  icon,
  additionalText }) => {
    return (
      <Paper variant='outlined' sx={{ backgroundColor: 'lightGrey.light', height: '150px', width: '100%', mt: marginTop, mb: marginBottom }}>
        <Stack display='flex' flexDirection='column' gap={2} justifyContent='center' alignItems='center' sx={{ height: '100%' }}>
          <Stack display='flex' flexDirection='row' gap={2} justifyContent='center' alignItems='center' >
            <IconPicker icon={icon} color={'text.secondary'} />
            <Typography sx={{ fontSize: '1rem', color: 'text.secondary' }}>{text}</Typography>
          </Stack>
          {additionalText && <Typography sx={{ fontSize: '1rem', color: 'text.secondary' }}>{additionalText}</Typography>}
          {actionText && link && <Box component={Link} to={link}><Typography sx={{ color: 'primary.main', textDecoration: 'underline', cursor: 'pointer' }}>{actionText}</Typography></Box>}
        </Stack>
      </Paper>
    )
  }